var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('DataGrid',{attrs:{"endpoint":("api/feedbacks/" + (_vm.feedback.idFeedback) + "/questions"),"columns":_vm.columns,"enableReorder":true,"primary":_vm.primary,"actions":_vm.actions}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }